import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('price-block')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-24 lg:pt-32 lg:pb-32 overflow-hidden" data-id="element-56">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-57">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-58">
          <FadeIn data-id="element-59">
            <div className="max-w-2xl" data-id="element-60">
              <span className="inline-block py-1 px-3 rounded-full bg-teal/10 text-teal-dark font-bold text-sm tracking-wider uppercase mb-6" data-id="element-61">
                Para mujeres de 65+ años
              </span>
              <h1 className="text-h2 md:text-h1 font-bold mb-6 leading-tight" data-id="element-62">
                Huesos Invencibles: El Método de 15 Minutos para Blindar tu
                Autonomía
              </h1>
              <p className="text-body-lg mb-8 text-charcoal/80" data-id="element-63">
                Fortalece tu densidad ósea y recupera la seguridad al caminar
                sin necesidad de gimnasios, pesas ni ejercicios de impacto.
              </p>
              <Button onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-64">
                Descargar Huesos Invencibles
                <ArrowRightIcon className="w-6 h-6" data-id="element-65" />
              </Button>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="relative" data-id="element-66">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] lg:aspect-square max-w-md mx-auto lg:max-w-none" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/oqsQ6RTyAeRMLrRTu2Zvd5/Huesos_rotos.png" alt="Huesos Invencibles Guía Digital en Tablet" className="w-full h-full object-cover" data-id="element-68" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/20 to-transparent" data-id="element-69"></div>
            </div>
            {/* Decorative background blob */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-teal/10 rounded-full blur-3xl" data-id="element-70"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}